import api from "./api";

const get = (userId) => {
  return api.get("/api/user-form-permission/get", { params: { userId } });
};

const getMany = (userIds) => {
  return api.post("/api/user-form-permission/get_many", { userIds });
};

const set = (userId, isFormEnabled) => {
  return api.post("/api/user-form-permission/set", { userId, isFormEnabled });
};

const UserFormPermissionService = {
  get,
  getMany,
  set,
};

export default UserFormPermissionService;
